<h2 mat-dialog-title translate style="margin: 0px">{{title}}</h2>


<mat-dialog-content>

    <table *ngIf="insertStep" class="table" style="width:100%;">
        <tr>
            <td>
                <tyl-radio-group label="" [(selected)]="insertStepType"
                    [values]="['Regular Step', 'Shared Test']"
                    [labels]="['Regular Step', 'Shared Test']"
                    [ids]="['rbRegularStep', 'Shared Test']"

                    arrange='horizontal'
                    style='padding-top:5px;margin-left: 10px;'>
                </tyl-radio-group>
            </td>
        </tr>
    </table>

    <table *ngIf="addParameter || editParameter" class="table" style="width:100%;">
            <tr>
                <td>Parameter Name</td>
                <td>Parameter Value</td>
            </tr>
            <tr style="border-bottom: silver;">
            <td>
                <textarea [required]  matInput style = 'background-color:#fefefe; width: 250px; font-size: 8pt; line-height:normal; border:1px solid Silver;'
                [(ngModel)]="parameter.ParameterName" spellcheck="false"
                id="txtParameterNamesModal"  name="txtParameterNamesModal" rows="3" ></textarea>
            </td>
            <td>
                <textarea  matInput style = 'background-color:#fefefe; width: 250px; font-size: 8pt; line-height:normal; border:1px solid Silver;'
                [(ngModel)]="parameter.ParameterValue" spellcheck="false"
                id="txtParameterValuesModal" name="txtParameterValueModal" rows="3" ></textarea>
            </td>

        </tr>

    </table>

  <!-- <span style="color: red;">insertStepType: {{ insertStepType }}</span>  -->
  <!-- <table *ngIf="!insertStep && !addParameter && !editParameter && !addStepComment && !editStepComment || addSubTest" class="table" style="width:100%;"> -->
    <table *ngIf="!insertStep && !addParameter && !editParameter || addSubTest" class="table" style="width:100%;">
        <tr>
            <td>Module</td>
            <td>Portal</td>
            <td>Test Name</td>
            <td *ngIf="addTest">Test Order</td>
            <td *ngIf="addTest"></td>
        </tr>
        <tr>
            <td>
                <!-- <mat-select id="ddlTestArea"  name="ddlTestArea" style="width: 175px; border:1px solid Silver;"
                [ngModel]="test.TestAreaName"
                (ngModelChange)="testArea = $event; testAreaChanged();"
            >
                <mat-option *ngFor="let item of testAreas" [value]="item">
                    {{item}}
                </mat-option>
            </mat-select> -->
                <mat-select id="ddlModalTestArea" name="ddlModalTestArea" style="width: 175px; border:1px solid Silver;"
                            [disabled]="insertStepType == 'Regular Step'"
                            [ngModel]="selectedArea"
                            (ngModelChange)="selectedArea = $event; testAreaChanged();">
                    <mat-option *ngFor="let item of distinctTestAreas" [value]="item.AreaName" (click)="setTestArea(item);">
                        {{item.AreaName}}
                    </mat-option>
                </mat-select>

            </td>
            <td>
                <mat-select id="ddlModalTestSubArea" name="ddlModalTestSubArea" style="width: 175px; border:1px solid Silver;"
                            [ngModel]="test.TestSubAreaName"
                            (ngModelChange)="testSubArea = $event; testSubAreaChanged($event);"
                            [disabled]="insertStepType == 'Regular Step'">
                    <mat-option *ngFor="let item of testSubAreas" [value]="item" (click)="setTestSubArea(item);">
                        {{item}}
                    </mat-option>
                </mat-select>
            </td>
            <td>
                <mat-select *ngIf="addSubTest" id="ddlModalTest" name="ddlModalTest" style="width: 175px; border:1px solid Silver;"
                            [ngModel]="test"
                            (ngModelChange)="test = $event;"
                            [disabled]="insertStepType == 'Regular Step'">
                    <mat-option *ngFor="let selectedTest of testsInArea" [value]="selectedTest">
                        {{selectedTest.TestName}}
                    </mat-option>
                </mat-select>

                <!--<tyl-button image="Copy.png" translate label="Copy Test" (clickEvent)="copyTestClick()"></tyl-button> -->
                <!-- #{{test.TestOrder}} <a (click)="testClick(test)">{{test.TestName}}</a> -->
                <textarea *ngIf="addTest || editTest" matInput style='background-color:#fefefe; width: 200px; font-size: 8pt; line-height:normal; border:1px solid Silver;'
                          [(ngModel)]="test.TestName" spellcheck="false"
                          id="txtTestName" name="txtTestName" rows="3"></textarea>
            </td>
            <td *ngIf="addTest || editTest">
                <textarea matInput style='background-color:#fefefe; width: 25px; font-size: 8pt; line-height:normal; border:1px solid Silver;'
                          [(ngModel)]="test.TestOrder" spellcheck="false"
                          id="txtTestOrder" name="txtTestOrder" rows="3"></textarea>
            </td>
            <td *ngIf="addTest || editTest">
                <tyl-checkbox [(checked)]="test.IsSubTestOnly" id="chkModalIsSubTestOnly"
                              name="chkModalIsSubTestOnly">
                    <!--(change)="isDebugModeInProductionChecked($event)"> -->
                    Shared Test
                </tyl-checkbox>

            </td>
            <!--(ngModelChange)="test.SelectedStatus = $event; ddlChange(parameter, $event);"-->
            <td *ngIf="addTest || editTest" style="padding-left: 15px;">
                <tyl-form-field label="Status">
                    <mat-select id="ddlTestStatus1" name="ddlTestStatus1"
                                [ngModel]="test.SelectedStatus"
                                (ngModelChange)="test.SelectedStatus = $event; testStatusChange(test, $event);">
                        <mat-option [value]="0">In Progress</mat-option>
                        <mat-option [value]="1">Ready for Review</mat-option>
                        <mat-option [value]="2">Approved</mat-option>
                        <mat-option [value]="3">Obsolete</mat-option>

                    </mat-select>
                </tyl-form-field>



                <!-- <tyl-checkbox [(checked)]="test.Approved" id="chkModalApproved{{$index}}"
            name="chkModalApproved{{$index}}">
            Is Approved
            </tyl-checkbox> -->

            </td>


        </tr>

        <tr *ngIf="addTest || editTest">
            <td colspan="6">
                Comments<br />
                <textarea matInput style='background-color:#FFFFFF; width: 100%; font-size: 8pt; line-height:normal; border:1px solid Silver;'
                          [(ngModel)]="test.Comments" spellcheck="true"
                          id="txtTestComments" name="txtTestComments" rows="10"></textarea>
            </td>
        </tr>


    </table>

    <!-- <table *ngIf="editStepComment || addStepComment" class="table" style="width:600px;">
        <tr>
            <td colspan="6">
                Comments<br />
                <textarea  matInput style = 'background-color:#FFFFFF; width: 100%; font-size: 8pt; line-height:normal; border:1px solid Silver;'
                [(ngModel)]="step.Comments"  spellcheck="true"
                id="txtStepComments"  name="txtStepComments" rows="4" ></textarea>
            </td>
        </tr>
    </table> -->


</mat-dialog-content>


<!-- Dialog Footer -->
<mat-dialog-actions>
    <!-- <div class='flex-footer-left' style="align-items: center; width: 50%">
        <tyl-button *ngIf="showTestSteps" style="color: black;" image="previous arrow.png"
        label="Tests" (clickEvent)="testsClick();"></tyl-button>
        <tyl-button *ngIf="showTests" image="add.png" translate label="Add Test" (clickEvent)="addTest()"></tyl-button>
        <tyl-button *ngIf="showTestSteps" image="add.png" translate label="Add Step" (clickEvent)="addStep(false)"></tyl-button>
        <tyl-button *ngIf="showTestSteps" image="add.png" translate label="Add Sub Test" (clickEvent)="addStep(true)"></tyl-button>
    </div> -->

    <div class='flex-footer-right' style="align-items: center; width: 50%">
        <tyl-button *ngIf="addTest || copyTest || editTest || addParameter || editParameter" image="save.png" translate label="Save" (clickEvent)="saveClick()"></tyl-button>
        <!-- <tyl-button *ngIf="addSubTest || insertStep || addStepComment || editStepComment" image="save.png" translate label="OK" (clickEvent)="okClick()"></tyl-button> -->
        <tyl-button *ngIf="addSubTest || insertStep" image="save.png" translate label="OK" (clickEvent)="okClick()"></tyl-button>
        <tyl-button image="cancel.png" translate label="Cancel" (clickEvent)="closeClick()"></tyl-button>
    </div>
</mat-dialog-actions>
